// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@ces/Overrides/Components/ProductPrice";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const unitOfMeasureText: TypographyPresentationProps = {
    size: 12,
    lineHeight: "16px",
    color: "common.ui5",
    css: css`
        white-space: nowrap;
    `,
};

productPriceStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: fit-content;
    `,
};

productPriceStyles.priceWrapper = {
    css: css`
        ${wrapInContainerStyles}
        display: flex;
        align-items: baseline;
        gap: 4px;
    `,
};

productPriceStyles.price = {
    priceText: {
        variant: "h5",
        forwardAs: "p",
        css: css`
            margin: 0;
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText,
    },
    errorText: { weight: "bold" },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    vatLabelText: {
        css: css`
            font-size: 12px;
        `,
    },
    signInText: {
        size: 12,
        lineHeight: "15px",
        css: css`
            margin-bottom: 4px;
            &&&& {
                a,
                a span {
                    color: ${color("secondary")};
                    &:not([disabled]):hover,
                    &:not([disabled]):focus {
                        color: ${color("common.ui9")};
                    }
                }
            }
        `,
    },
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText,
};

productPriceStyles.quoteMessageWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
    `,
};

productPriceStyles.quoteMessage = {
    text: {
        size: 14,
        lineHeight: "19px",
        weight: fontConfig.weight.bold,
    },
};
